import { useEffect, useState } from "react";
import { createClient } from "../../api/clients.api";
import "./RendezVous.css";

const RendezVousForm = ({
  onSubmit,
  initialData,
  techniciens,
  clients,
  entretiens,
  onClientCreated
}) => {

  const [showClientForm, setShowClientForm] = useState(false);

  const [newClient, setNewClient] = useState({
    nom: "",
    telephone: "",
    adresse: ""
  });

  const [form, setForm] = useState({
    client_id: "",
    type_entretien_id: "",
    date_rdv: "",
    heure_debut: "",
    heure_fin: "",
    etat_travaux: "EN_ATTENTE",
    techniciens_id: "",
    note: ""
  });

  // Recherche client
  const [searchClient, setSearchClient] = useState("");

  const [showClientResults, setShowClientResults] =
    useState(false);


  // =========================
  // INITIALISATION
  // =========================

  useEffect(() => {

    if (initialData) {

      setForm({
        ...initialData,

        client_id:
          String(initialData.client_id || ""),

        type_entretien_id:
          String(initialData.type_entretien_id || ""),

        techniciens_id:
          String(initialData.techniciens_id || ""),

        note:
          initialData.note || "",

        remarque:
          initialData.remarque || ""
      });


      // Afficher le nom du client sélectionné
      const client = clients?.find(
        (c) =>
          Number(c.id) ===
          Number(initialData.client_id)
      );

      if (client) {
        setSearchClient(client.nom || "");
      }

    } else {

      setForm({
        client_id: "",
        type_entretien_id: "",
        date_rdv: "",
        heure_debut: "",
        heure_fin: "",
        etat_travaux: "EN_ATTENTE",
        techniciens_id: "",
        note: ""
      });

      setSearchClient("");

    }

  }, [initialData, clients]);


  // =========================
  // CHANGEMENT CHAMPS
  // =========================

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };


  // =========================
  // RECHERCHE CLIENT
  // =========================

  const filteredClients = (clients || []).filter(
    (client) => {

      const nom =
        client?.nom || "";

      const telephone =
        client?.telephone || "";

      const recherche =
        searchClient
          .toLowerCase()
          .trim();

      return (
        nom
          .toLowerCase()
          .includes(recherche) ||

        String(telephone)
          .toLowerCase()
          .includes(recherche)
      );

    }
  );


  // =========================
  // SÉLECTION CLIENT
  // =========================

  const handleSelectClient = (client) => {

    setForm((prev) => ({
      ...prev,
      client_id: String(client.id)
    }));

    setSearchClient(
      client.nom || ""
    );

    setShowClientResults(false);

  };


  // =========================
  // RECHERCHE CLIENT
  // =========================

  const handleSearchClient = (e) => {

    const value = e.target.value;

    setSearchClient(value);

    // Si on modifie la recherche,
    // on enlève l'ancien client sélectionné

    setForm((prev) => ({
      ...prev,
      client_id: ""
    }));

    setShowClientResults(true);

  };


  // =========================
  // EFFACER CLIENT
  // =========================

  const clearClient = () => {

    setSearchClient("");

    setForm((prev) => ({
      ...prev,
      client_id: ""
    }));

    setShowClientResults(true);

  };


  // =========================
  // SOUMISSION
  // =========================

  const handleSubmit = (e) => {

    e.preventDefault();

    if (!form.client_id) {

      alert(
        "Veuillez sélectionner un client."
      );

      return;
    }

    onSubmit(form);

  };


  // =========================
  // AJOUTER CLIENT
  // =========================

  const handleAddClient = async (e) => {

    e.preventDefault();

    try {

      const response =
        await createClient(newClient);

      /*
       * Selon ton API, createClient peut
       * retourner directement le client
       * ou un objet axios.
       */

      const client =
        response?.data || response;

      if (!client?.id) {

        throw new Error(
          "Le client créé est invalide."
        );

      }


      // Ajouter le client à la liste
      if (onClientCreated) {
        onClientCreated(client);
      }


      // Sélection automatique
      setForm((prev) => ({
        ...prev,
        client_id:
          String(client.id)
      }));


      setSearchClient(
        client.nom || ""
      );


      setShowClientForm(false);


      setNewClient({
        nom: "",
        telephone: "",
        adresse: ""
      });


      alert(
        "Client ajouté avec succès !"
      );

    } catch (error) {

      console.error(
        "Erreur ajout client :",
        error
      );

      alert(
        error.response?.data?.message ||
        error.message ||
        "Erreur lors de l'ajout du client"
      );

    }

  };


  return (

    <>

      <form
        onSubmit={handleSubmit}
        className="rendezvous-form"
      >

        {/* =========================
            CLIENT
        ========================== */}

        <div className="client-select-container">

          <label>
            Client
          </label>

          <div className="client-search-row">

            <div className="client-search-box">

              <input
                type="text"
                value={searchClient}
                onChange={handleSearchClient}
                onFocus={() => {

                  setShowClientResults(true);

                }}
                placeholder="🔍 Rechercher un client..."
                autoComplete="off"
                required={!form.client_id}
              />


              {searchClient && (

                <button
                  type="button"
                  className="clear-client-search"
                  onClick={clearClient}
                  title="Effacer"
                >
                  ✕
                </button>

              )}


              {/* =========================
                  RÉSULTATS CLIENTS
              ========================== */}

              {showClientResults &&
               searchClient.trim() && (
                
                <div className="client-search-results">

                  {filteredClients.length > 0 ? (

                    filteredClients
                      .slice(0, 15)
                      .map((client) => (

                        <div
                          key={client.id}
                          className={
                            `client-search-result ${
                              Number(form.client_id) ===
                              Number(client.id)
                                ? "selected"
                                : ""
                            }`
                          }
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleSelectClient(client);
                          }}
                        >

                          <div className="client-result-name">

                            👤 {client.nom}

                          </div>


                          {client.telephone && (

                            <div className="client-result-phone">

                              📞 {client.telephone}

                            </div>

                          )}

                        </div>

                      ))

                  ) : (

                    <div className="client-no-result">

                      Aucun client trouvé

                    </div>

                  )}

                </div>

              )}

            </div>


            {/* AJOUT CLIENT */}

            <button
              type="button"
              className="btn-add-client"
              onClick={() =>
                setShowClientForm(true)
              }
            >
              + Ajouter client
            </button>

          </div>


          {/* CLIENT SÉLECTIONNÉ */}

          {form.client_id && (

            <div className="selected-client">

              ✓ Client sélectionné :
              {" "}
              <strong>
                {searchClient}
              </strong>

            </div>

          )}

        </div>


        {/* =========================
            TYPE ENTRETIEN
        ========================== */}

        <select
          name="type_entretien_id"
          value={form.type_entretien_id}
          onChange={handleChange}
          required
        >

          <option value="">
            Type entretien
          </option>

          {entretiens?.map((entretien) => (

            <option
              key={entretien.id}
              value={entretien.id}
            >
              {entretien.nom}
            </option>

          ))}

        </select>


        {/* =========================
            DATE
        ========================== */}

        <input
          type="date"
          name="date_rdv"
          value={form.date_rdv || ""}
          onChange={handleChange}
          required
        />


        {/* =========================
            HEURE DÉBUT
        ========================== */}

        <input
          type="time"
          name="heure_debut"
          value={form.heure_debut || ""}
          onChange={handleChange}
          required
        />


        {/* =========================
            HEURE FIN
        ========================== */}

        {form.etat_travaux === "TERMINE" && (

          <input
            type="time"
            name="heure_fin"
            value={form.heure_fin || ""}
            onChange={handleChange}
          />

        )}


        {/* =========================
            NOTE ADMINISTRATEUR
        ========================== */}

        <textarea
          name="note"
          value={form.note || ""}
          onChange={handleChange}
          placeholder="📝 Note administrateur..."
          rows="3"
        />


       
        {/* =========================
            TECHNICIEN
        ========================== */}

        <select
          name="techniciens_id"
          value={form.techniciens_id}
          onChange={handleChange}
          required
        >

          <option value="">
            Technicien
          </option>

          {techniciens?.map((technicien) => (

            <option
              key={technicien.id}
              value={technicien.id}
            >
              {technicien.nom}
            </option>

          ))}

        </select>


        {/* =========================
            BOUTON
        ========================== */}

        <button type="submit">

          {initialData
            ? "Modifier"
            : "Ajouter"}

        </button>

      </form>


      {/* =========================
          MODAL CLIENT
      ========================== */}

      {showClientForm && (

        <div className="modal-overlay">

          <div className="modal-content">

            <h3>
              Nouveau client
            </h3>


            <form
              onSubmit={handleAddClient}
            >

              <input
                type="text"
                placeholder="Nom"
                value={newClient.nom}
                onChange={(e) =>
                  setNewClient({
                    ...newClient,
                    nom: e.target.value
                  })
                }
                required
              />


              <input
                type="text"
                placeholder="Adresse"
                value={newClient.adresse}
                onChange={(e) =>
                  setNewClient({
                    ...newClient,
                    adresse: e.target.value
                  })
                }
                required
              />


              <input
                type="text"
                placeholder="Téléphone"
                value={newClient.telephone}
                onChange={(e) =>
                  setNewClient({
                    ...newClient,
                    telephone: e.target.value
                  })
                }
                required
              />


              <div className="modal-actions">

                <button type="submit">
                  Enregistrer
                </button>

                <button
                  type="button"
                  onClick={() =>
                    setShowClientForm(false)
                  }
                >
                  Annuler
                </button>

              </div>

            </form>

          </div>

        </div>

      )}

    </>

  );

};

export default RendezVousForm;
